import { usePage } from "@inertiajs/react";

export const useIsEligibilityReadOnly = (): boolean => {
    const contact = usePage().props?.contact as powerready.contact.IBDContact;
    return !!contact?.query_params?.project;
};
